export const REWARD_OVERVIEW_STATUSES = {
  REDEEMED: 'Redeemed',
  PENDING: 'Pending',
  SENT: 'Sent'
}
